import React, { useState } from 'react';
import { Box, Text } from 'ink';
import { type SpinnerName } from 'cli-spinners';
import interpolate from 'color-interpolate';
import { colors } from '../colors';
import { useInterval } from '../hooks/use_interval';
import { useSpinnerFrame } from '../hooks/use_spinner_frame';

const colorFrames = [
  colors.gitlabRed,
  colors.gitlabOrange,
  colors.gitlabYellow,
  colors.gitlabOrange,
  colors.gitlabRed,
];

const colormap = interpolate(colorFrames);

const CHANGE_INTERVAL_MS = 250;

interface SpinnerProps {
  changeColors?: boolean;
  spinner?: SpinnerName;
  text?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  changeColors,
  spinner: spinnerName = 'dotsCircle',
  text,
}) => {
  const frame = useSpinnerFrame(spinnerName, true, CHANGE_INTERVAL_MS);
  const [colorFrame, setColor] = useState(0);
  const color = changeColors ? colormap(colorFrame) : undefined;

  useInterval(() => {
    setColor((previousColor) => {
      return ((previousColor * 100 + 5) % 100) / 100;
    });
  }, CHANGE_INTERVAL_MS);

  return (
    <Box>
      <Text color={color}>{frame}</Text>
      {text && <Text color={color}>{` ${text}`}</Text>}
    </Box>
  );
};
